<template>
  <div class="tabbar">
    <div class="line">
      <div class="tab-list">
        <div
          class="tab-item"
          v-for="(item, index) in tabList"
          :key="index"
          :class="tabIndex == index ? 'tab-active' : ''"
          @click="handleTab(item, index)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    playerList: {
      type: Array,
      defalut: () => [],
    },
  },
  components: {},
  data() {
    return {
      tabIndex: 0,
      tabList: [
        {
          name: '赛事主页',
        },
        {
          name: '赛程',
        },
        {
          name: '奖牌牌',
        },
        {
          name: '赛事公告',
        },
        // {
        //   name: '积分榜',
        // },
        // {
        //   name: '数据中心',
        // },
      ],
      matchIndex: 0,
      playerDetai: false,
      component: 'BasketballInfo',
    }
  },
  mounted() {},
  methods: {
    handleTab(item, index) {
      this.tabIndex = index
      switch (this.tabIndex) {
        case 0:
          this.component = 'BasketballInfo'
          break
        case 1:
          // this.component='BasketballSchedule'
          this.component = 'MatchVolleyballSchedule'
          break
        case 2:
          this.component = 'MatchVolleyballRank'
          break
        case 3:
          this.component = 'MatchNotice'
          break
        case 4:
          this.component = 'BigGameScore'
          break
        case 5:
          this.component = 'BasketballDateCenter'
          break
        default:
          this.component = 'BasketballInfo'
      }
      this.$emit('setComponent', this.component)
    },
  },
}
</script>

<style lang="scss" scoped>
.tabbar {
  width: 100%;
  padding-top: 10px;
  // 导航列表
  .line {
    border-bottom: 1px solid #e1e1e1;
    .tab-list {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      color: #000000;
      .tab-item {
        width: 120px;
        height: 50px;
        line-height: 50px;
        border-radius: 20px 20px 0 0;
        text-align: center;
        margin-right: 20px;
        cursor: pointer;
        font-size: 18px;
      }
    }
    .tab-active {
      background-color: #aa1f23;
      color: #ffffff;
      font-size: 22px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/comm/components/match/basketball/components/BasketballMatchTabbar.vue